export const validateName = (name: string): boolean => {
  const regex = /^.{2,20}$/;

  return regex.test(name);
};
